import { Box, Card, Skeleton, Typography } from "@mui/material";

export default function DetectionDetailsSkeleton({ title, tilesCount }: any) {
  return (
    <>
      <Box
        sx={{
          mb: 3,
          p: 2,
          bgcolor: "#fff",
          borderRadius: 2,
          boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.05) !important",
        }}
      >
        <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: "bold" }}>
          <Skeleton variant="text" width={70} height={20} />
        </Typography>
        <Box
          sx={{
            display: "-webkit-box",
            flexWrap: "wrap",
            gap: 2,
            justifyContent: "flex-start",
          }}
        >
          {new Array(tilesCount).fill(null).map((__, index) => (
            <Card
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
                p: 1.5,
                gap: 1.5,
                borderRadius: 3,
                boxShadow: 2,
                minWidth: 120,
              }}
            >
              <Skeleton variant="circular" width={40} height={40} />
              <Typography variant="body1" fontWeight="bold">
                <Skeleton variant="text" width={80} height={20} />
              </Typography>
            </Card>
          ))}
        </Box>
      </Box>
    </>
  );
}
